import Vue from 'vue'
import Vuex from 'vuex'
import authentication from '@/store/modules/authentication'
import home from '@/store/modules/home'
import firebaseauth from '@/store/modules/firebaseauth'
import addholdings from '@/store/modules/addholdings'
import loading from '@/store/modules/loading'
import portfolioreport from '@/store/modules/portfolioreport'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        authentication,
        firebaseauth,
        home,
		addholdings,
        loading,
        portfolioreport
    }
})




// WEBPACK FOOTER //
// ./src/store/index.js